module.exports = __webpack_public_path__ + "img/tx4@3x.bd965df3.svg";